import { render, staticRenderFns } from "./D2FolderDetail.vue?vue&type=template&id=4be21b8f"
import script from "./D2FolderDetail.vue?vue&type=script&lang=js"
export * from "./D2FolderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports